import React, { forwardRef, useId } from 'react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, className = '', id, ...props }, ref) => {
    const autoId = useId();
    const checkboxId = id || autoId;

    return (
      <label htmlFor={checkboxId} className={`checkbox-wrapper ${className}`}>
        <input
          ref={ref}
          type="checkbox"
          id={checkboxId}
          className="checkbox"
          {...props}
        />
        {label && (
          <span style={{ fontFamily: 'var(--font-body)', fontSize: 'var(--text-base)' }}>
            {label}
          </span>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
